
export const TRACK_TRIP_SUMMARY_DEFAULT_TEMPLATE: object = {
  op: 'ui',
  name: 'Box',
  style: { columnGap: 12, display: 'flex', justifyContent: 'space-between' },
  children: [
    // Column 1: Duration + Odometer
    {
      op: 'ui',
      name: 'Stack',
      spacing: 1.5,
      style: { flex: '0 1 calc((100% - 24px) / 3)' },
      children: [
        {
          op: 'ui',
          name: 'SummaryItem',
          icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Clock' },
          children: {
            op: 'ui',
            name: 'Typography',
            variant: 'body2',
            children: {
              op: 'format-duration',
              minutes: { op: 'context', path: 'durationMinutes' },
              display: 'narrow',
              shiftTo: ['hours', 'minutes'],
            },
          },
        },
        {
          op: 'if',
          condition: {
            op: 'and',
            values: [
              { op: 'not', value: { op: 'context', path: 'thing-activity.isOngoing' } },
              { op: 'context', path: 'events.distancePrimaryEnd' },
            ],
          },
          then: {
            op: 'ui',
            name: 'Tooltip',
            placement: 'bottom',
            title: {
              op: 'ui',
              name: 'Stack',
              spacing: 0.5,
              style: { minWidth: 210 },
              children: [
                {
                  op: 'ui',
                  name: 'Stack',
                  direction: 'row',
                  justifyContent: 'space-between',
                  spacing: 1.5,
                  children: [
                    { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'array-join', separator: '', value: [{ op: 'array-join', separator: ' ', value: [{ op: 'translate', translation: 'common:component.recent-metrics.odometer.label' }, { op: 'translate', translation: 'common:terms.start' }] }, ':'] } },
                    { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'format-distance', meters: { op: 'context', path: 'events.distancePrimaryStart.data.value' }, unit: 'kilometer', display: 'short' } },
                  ],
                },
                {
                  op: 'ui',
                  name: 'Stack',
                  direction: 'row',
                  justifyContent: 'space-between',
                  spacing: 1.5,
                  children: [
                    { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'array-join', separator: '', value: [{ op: 'array-join', separator: ' ', value: [{ op: 'translate', translation: 'common:component.recent-metrics.odometer.label' }, { op: 'translate', translation: 'track:page.history.trip-base-view.labels.end' }] }, ':'] } },
                    { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'format-distance', meters: { op: 'context', path: 'events.distancePrimaryEnd.data.value' }, unit: 'kilometer', display: 'short' } },
                  ],
                },
              ],
            },
            children: {
              op: 'ui',
              name: 'SummaryItem',
              icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Gauge' },
              children: {
                op: 'ui',
                name: 'Typography',
                style: { textDecorationLine: 'underline', textDecorationStyle: 'dotted' },
                variant: 'body2',
                children: { op: 'format-distance', meters: { op: 'context', path: 'events.distancePrimaryEnd.data.value' }, unit: 'kilometer', display: 'short' },
              },
            },
          },
        },
      ],
    },
    // Column 2: Distance + Engine hours
    {
      op: 'if',
      condition: { op: 'not', value: { op: 'context', path: 'thing-activity.isOngoing' } },
      then: {
        op: 'ui',
        name: 'Stack',
        spacing: 1.5,
        style: { flex: '0 1 calc((100% - 24px) / 3)' },
        children: [
          {
            op: 'if',
            condition: { op: 'context', path: 'events.distancePrimaryIncrease' },
            then: {
              op: 'ui',
              name: 'SummaryItem',
              icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Trip' },
              children: {
                op: 'ui',
                name: 'Typography',
                variant: 'body2',
                children: {
                  op: 'array-join',
                  separator: ' ',
                  value: [
                    {
                      op: 'format-number',
                      value: {
                        op: 'divide',
                        a: { op: 'context', path: 'events.distancePrimaryIncrease.data.increase' },
                        b: 1000,
                      },
                      fractionDigits: 0,
                    },
                    'km',
                  ],
                },
              },
            },
          },
          {
            op: 'if',
            condition: { op: 'context', path: 'events.engineRunningEnd' },
            then: {
              op: 'ui',
              name: 'Tooltip',
              placement: 'bottom',
              title: {
                op: 'ui',
                name: 'Stack',
                spacing: 0.5,
                style: { minWidth: 210 },
                children: [
                  {
                    op: 'ui',
                    name: 'Stack',
                    direction: 'row',
                    justifyContent: 'space-between',
                    spacing: 1.5,
                    children: [
                      { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'array-join', separator: '', value: [{ op: 'array-join', separator: ' ', value: [{ op: 'translate', translation: 'common:component.recent-metrics.engine-hours.label' }, { op: 'translate', translation: 'common:terms.start' }] }, ':'] } },
                      { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'format-duration', minutes: { op: 'context', path: 'events.engineRunningStart.data.duration' }, display: 'narrow', shiftTo: ['hours'] } },
                    ],
                  },
                  {
                    op: 'ui',
                    name: 'Stack',
                    direction: 'row',
                    justifyContent: 'space-between',
                    spacing: 1.5,
                    children: [
                      { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'array-join', separator: '', value: [{ op: 'array-join', separator: ' ', value: [{ op: 'translate', translation: 'common:component.recent-metrics.engine-hours.label' }, { op: 'translate', translation: 'track:page.history.trip-base-view.labels.end' }] }, ':'] } },
                      { op: 'ui', name: 'Typography', variant: 'body2', children: { op: 'format-duration', minutes: { op: 'context', path: 'events.engineRunningEnd.data.duration' }, display: 'narrow', shiftTo: ['hours'] } },
                    ],
                  },
                ],
              },
              children: {
                op: 'ui',
                name: 'SummaryItem',
                icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Engine' },
                children: {
                  op: 'ui',
                  name: 'Typography',
                  style: { textDecorationLine: 'underline', textDecorationStyle: 'dotted' },
                  variant: 'body2',
                  children: { op: 'format-duration', minutes: { op: 'context', path: 'events.engineRunningEnd.data.duration' }, display: 'narrow', shiftTo: ['hours'] },
                },
              },
            },
          },
        ],
      },
    },
    // Column 3: Fuel consumed + Fuel efficiency
    {
      op: 'if',
      condition: { op: 'not', value: { op: 'context', path: 'thing-activity.isOngoing' } },
      then: {
        op: 'ui',
        name: 'Stack',
        spacing: 1.5,
        style: { flex: '0 1 calc((100% - 24px) / 3)' },
        children: [
          {
            op: 'if',
            condition: { op: 'context', path: 'events.fuelConsumed' },
            then: {
              op: 'ui',
              name: 'SummaryItem',
              icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Fuel' },
              children: {
                op: 'ui',
                name: 'Typography',
                variant: 'body2',
                children: {
                  op: 'array-join',
                  separator: ' ',
                  value: [
                    {
                      op: 'format-number',
                      value: {
                        op: 'divide',
                        a: { op: 'context', path: 'events.fuelConsumed.data.increase' },
                        b: 1000,
                      },
                      fractionDigits: 1,
                    },
                    'L',
                  ],
                },
              },
            },
          },
          {
            op: 'if',
            condition: {
              op: 'and',
              values: [
                { op: 'context', path: 'events.distancePrimaryIncrease.data.increase' },
                { op: 'context', path: 'events.fuelConsumed.data.increase' },
                { op: 'gt', 'left': { op: 'context', path: 'events.fuelConsumed.data.increase' }, 'right': 0 },
              ],
            },
            then: {
              op: 'ui',
              name: 'Tooltip',
              placement: 'bottom',
              title: { op: 'translate', translation: 'common:page.history.trip-base-view.tooltips.fuel-efficiency' },
              children: {
                op: 'ui',
                name: 'SummaryItem',
                icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Fuel' },
                children: {
                  op: 'ui',
                  name: 'Typography',
                  variant: 'body2',
                  // meters / milliliters = km/L (units cancel: both divide by 1000)
                  children: {
                    op: 'array-join',
                    separator: ' ',
                    value: [
                      {
                        op: 'format-number',
                        value: {
                          op: 'divide',
                          a: { op: 'context', path: 'events.distancePrimaryIncrease.data.increase' },
                          b: { op: 'context', path: 'events.fuelConsumed.data.increase' },
                        },
                        fractionDigits: 1,
                      },
                      'km/L',
                    ],
                  },
                },
              },
            },
          },
        ],
      },
    },
  ],
};

export const TRACK_TRIP_TIMELINE_ITEM_DEFAULT_TEMPLATE: object = {
  op: 'ui',
  name: 'Stack',
  spacing: 0.25,
  style: { minWidth: 0 },
  children: [
    {
      op: 'ui',
      name: 'Box',
      style: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 1 },
      children: [
        {
          op: 'ui',
          name: 'Typography',
          variant: 'body2',
          children: { op: 'context', path: 'item.label' },
        },
        {
          op: 'if',
          condition: { op: 'context', path: 'item.time' },
          then: {
            op: 'ui',
            name: 'Tooltip',
            title: {
              op: 'format-timestamp',
              value: { op: 'context', path: 'event.occurred' },
              format: 'dd LLL yyyy, hh:mm a',
            },
            children: {
              op: 'ui',
              name: 'Typography',
              color: 'text.secondary',
              variant: 'caption',
              style: { whiteSpace: 'nowrap', flexShrink: 0 },
              children: { op: 'context', path: 'item.time' },
            },
          },
        },
      ],
    },
    {
      op: 'if',
      condition: { op: 'context', path: 'item.subtitle' },
      then: {
        op: 'ui',
        name: 'Typography',
        color: 'text.secondary',
        noWrap: true,
        variant: 'caption',
        children: { op: 'context', path: 'item.subtitle' },
      },
    },
  ],
};

export const TRACK_TRIP_TIMELINE_MARKER_DEFAULT_TEMPLATE: object = {
  op: 'if',
  condition: { op: 'eq', a: { op: 'context', path: 'item.type' }, b: 'event' },
  then: {
    op: 'ui',
    name: 'Box',
    bgcolor: { op: 'context', path: 'item.color' },
    style: {
      borderRadius: '50%',
      height: 16,
      width: 16,
    },
  },
  else: {
    op: 'if',
    condition: { op: 'eq', a: { op: 'context', path: 'item.type' }, b: 'ongoing' },
    then: {
      op: 'ui',
      name: 'PulseIndicator',
      size: 16,
    },
    else: {
      op: 'ui',
      name: 'Stack',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: { op: 'context', path: 'item.color' },
      style: {
        borderRadius: '50%',
        color: '#fff',
        height: 24,
        width: 24,
      },
      children: {
        op: 'ui',
        name: 'Icon',
        fontSize: 'extra-small',
        icon: {
          op: 'if',
          condition: { op: 'eq', a: { op: 'context', path: 'item.type' }, b: 'start' },
          then: 'ArrowDown',
          else: 'Flag',
        },
      },
    },
  },
};

export const TRACK_TRIP_SUMMARY_CARD_DEFAULT_TEMPLATE: object = {
  op: 'ui',
  name: 'RecordSummaryCard',
  accentColor: { op: 'context', path: 'ui.accentColor' },
  clickable: true,
  selected: { op: 'context', path: 'ui.selected' },
  leading: {
    op: 'if',
    condition: { op: 'context', path: 'trip.isOngoing' },
    then: { op: 'ui', name: 'PulseIndicator', size: 16 },
    else: {
      op: 'ui',
      name: 'Stack',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: { op: 'context', path: 'ui.accentColor' },
      style: { borderRadius: '50%', color: '#fff', height: 32, width: 32, flexShrink: 0 },
      children: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Flag' },
    },
  },
  title: {
    op: 'ui',
    name: 'Typography',
    variant: 'body2',
    style: { alignItems: 'center', display: 'flex', gap: 6, whiteSpace: 'nowrap' },
    children: [
      {
        op: 'ui',
        name: 'Tooltip',
        placement: 'bottom',
        title: { op: 'context', path: 'ui.startDateTime' },
        children: { op: 'ui', name: 'Box', component: 'span', children: { op: 'context', path: 'ui.startTime' } },
      },
      { op: 'ui', name: 'Box', component: 'span', children: '-' },
      {
        op: 'ui',
        name: 'Tooltip',
        placement: 'bottom',
        title: {
          op: 'if',
          condition: { op: 'context', path: 'trip.isOngoing' },
          then: { op: 'translate', translation: 'track:page.history.trip-base-view.labels.current' },
          else: { op: 'context', path: 'ui.endDateTime' },
        },
        children: {
          op: 'ui',
          name: 'Box',
          component: 'span',
          children: {
            op: 'if',
            condition: { op: 'context', path: 'trip.isOngoing' },
            then: { op: 'translate', translation: 'track:page.history.trip-base-view.labels.current' },
            else: { op: 'context', path: 'ui.endTime' },
          },
        },
      },
    ],
  },
  subtitle: {
    op: 'if',
    condition: { op: 'context', path: 'ui.isLoading' },
    then: { op: 'ui', name: 'Skeleton', height: 18, variant: 'text', width: 180 },
    else: {
      op: 'ui',
      name: 'Stack',
      alignItems: 'center',
      direction: 'row',
      spacing: 0.5,
      children: [
        {
          op: 'ui',
          name: 'Tooltip',
          placement: 'bottom',
          title: { op: 'context', path: 'ui.routeFullAddress.start' },
          children: {
            op: 'ui',
            name: 'Typography',
            color: 'text.secondary',
            variant: 'caption',
            children: { op: 'context', path: 'ui.routeLabel.start' },
          },
        },
        { op: 'ui', name: 'Typography', color: 'text.secondary', variant: 'caption', children: '->' },
        {
          op: 'if',
          condition: { op: 'context', path: 'trip.isOngoing' },
          then: {
            op: 'ui',
            name: 'Typography',
            color: 'text.secondary',
            variant: 'caption',
            children: { op: 'translate', translation: 'track:page.history.trip-base-view.labels.current' },
          },
          else: {
            op: 'ui',
            name: 'Tooltip',
            placement: 'bottom',
            title: { op: 'context', path: 'ui.routeFullAddress.end' },
            children: {
              op: 'ui',
              name: 'Typography',
              color: 'text.secondary',
              variant: 'caption',
              children: { op: 'context', path: 'ui.routeLabel.end' },
            },
          },
        },
      ],
    },
  },
  items: { op: 'context', path: 'items' },
};

export const TRACK_THING_SUMMARY_STATISTICS_DEFAULT_TEMPLATE: object = {
  op: 'ui',
  name: 'Box',
  style: { display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', columnGap: 24, rowGap: 8 },
  children: [
    {
      op: 'if',
      condition: { op: 'context', path: 'trip-count' },
      then: {
        op: 'ui',
        name: 'Tooltip',
        placement: 'bottom',
        title: { op: 'translate', translation: 'track:page.history.trip-base-view.tooltips.total-trips-distance' },
        children: {
          op: 'ui',
          name: 'SummaryItem',
          icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Trip' },
          children: {
            op: 'ui',
            name: 'Typography',
            variant: 'body2',
            children: {
              op: 'array-join',
              separator: ', ',
              value: [
                { op: 'array-join', separator: '', value: [{ op: 'context', path: 'trip-count' }, ' Trips'] },
                { op: 'format-distance', meters: { op: 'context', path: 'distance' }, unit: 'kilometer', display: 'short' },
              ],
            },
          },
        },
      },
    },
    {
      op: 'if',
      condition: { op: 'context', path: 'fuel-consumed' },
      then: {
        op: 'ui',
        name: 'Tooltip',
        placement: 'bottom',
        title: { op: 'translate', translation: 'track:page.history.trip-base-view.tooltips.total-fuel-consumed' },
        children: {
          op: 'ui',
          name: 'SummaryItem',
          icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Fuel' },
          children: {
            op: 'ui',
            name: 'Typography',
            variant: 'body2',
            children: {
              op: 'array-join',
              separator: ' ',
              value: [
                { op: 'format-number', value: { op: 'divide', a: { op: 'context', path: 'fuel-consumed' }, b: 1000 }, fractionDigits: 1 },
                'L',
              ],
            },
          },
        },
      },
    },
    {
      op: 'if',
      condition: { op: 'context', path: 'duration' },
      then: {
        op: 'ui',
        name: 'Tooltip',
        placement: 'bottom',
        title: { op: 'translate', translation: 'track:page.history.trip-base-view.tooltips.total-duration' },
        children: {
          op: 'ui',
          name: 'SummaryItem',
          icon: { op: 'ui', name: 'Icon', fontSize: 'small', icon: 'Clock' },
          children: {
            op: 'ui',
            name: 'Typography',
            variant: 'body2',
            children: { op: 'format-duration', minutes: { op: 'context', path: 'duration' }, display: 'narrow', shiftTo: ['hours', 'minutes'] },
          },
        },
      },
    },
    { op: 'ui', name: 'Box' },
  ],
};
